import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 67.478 100"
    ref={ref}
    {...props}
  >
    <path d="M59.768.041a8.54 8.54 0 0 0-6.25 1.902L3.11 43.408a8.537 8.537 0 0 0 0 13.184l50.407 41.465a8.537 8.537 0 0 0 12.015-1.17 8.537 8.537 0 0 0-1.17-12.016L21.971 50l42.392-34.871a8.537 8.537 0 0 0 1.17-12.016A8.54 8.54 0 0 0 59.768.041" />
  </svg>
);
const ForwardRef = forwardRef(SvgArrowLeft);
export default ForwardRef;
